import Vue from "vue";
import App from "./App.vue";

import { store } from './_store';
import router from "./router";
import data from "./data/data.js";
import { settingsService } from "./services";

import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents);

import "./sass/main.scss";

Vue.config.productionTip = false;

// Get site settings 
settingsService.getSiteSettings().then(settings => {
    data.siteSettings = settings;
});

new Vue({
    router,
    store,
    render: h => h(App),
    data: data
}).$mount("#app");

document.oncontextmenu = function () {
    return false;
}